
'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';

export function DemoBanner() {
  const t = useTranslations('demo');

  return (
    <div className="fixed top-0 left-0 w-full h-11 bg-black text-white z-[9999] flex items-center justify-between px-4 md:px-8">
      <div className="text-[10px] md:text-xs font-mono tracking-tight">
        <span className="hidden sm:inline">{t('banner')}</span>
        <span className="sm:hidden">{t('short')}</span>
      </div>
      <Link href="/" className="text-[10px] md:text-xs font-semibold hover:underline flex items-center gap-2">
        {t('cta')}
      </Link>
    </div>
  );
}
